import { useEffect } from 'react';
import { useApplicationOperations } from './useApplicationOperations';
import { useIsUnknownUser } from 'store/features/auth/selectors';

import { useIsAllowDependsOnContour } from 'entities/application';

export const useInitFeatureFlags = () => {
  const { getFeatureFlags } = useApplicationOperations();
  const isUnknownUser = useIsUnknownUser();
  const isAllowDependsOnContour = useIsAllowDependsOnContour();

  useEffect(() => {
    if (isAllowDependsOnContour && !isUnknownUser) {
      getFeatureFlags();
    }
  }, [
    getFeatureFlags,
    isUnknownUser,
    isAllowDependsOnContour
  ]);
};
